/**
 * Created by hawlik on 08.02.18.
 */
export class Country {
  constructor(public id: number, public name: string) {

  }
}
